import type { LoaderFunctionArgs } from 'react-router-dom';
import { LeadId } from '@/models/entities/lead.ts';
import { leadService } from '@/services/leadService.ts';

export const leadDetailsRouteLoader = async ({
  params,
}: LoaderFunctionArgs) => {
  const leadId = LeadId.parse(params.leadId);
  const response = await leadService.getNotes(leadId);

  if (!response.ok) {
    throw new Error('Failed to load historical notes');
  }
  return response.domain;
};
